module.exports = __webpack_public_path__ + "img/blue-add-icon.40196a9c.svg";